export const CONSENT_TYPES = {
    PRIVACY_POLICY_RECRUITMENT_SERVICES: 'PRIVACY_POLICY_RECRUITMENT_SERVICES',
    PRIVACY_POLICY_CANDIDATE_SERVICES: 'PRIVACY_POLICY_CANDIDATE_SERVICES',
    OLD_TERMS_OF_SERVICE: 'OLD_TERMS_OF_SERVICE',
    TERMS_OF_SERVICE: 'TERMS_OF_SERVICE',
    SUB_PROCESSORS: 'SUB_PROCESSORS',
    SECURITY: 'SECURITY',
    PRIVACY_POLICY: 'PRIVACY_POLICY'
} as const;
